import React from 'react';
import { Select } from 'antd';
import timezones from './timezones.json';

interface TimezoneSelectorProps {
    timezoneId?: string;
    onTimezoneChange: (timezoneId: string) => void;
    editable: boolean;
    showTitle?: boolean;
}
const TimezoneSelector = ({
    timezoneId,
    onTimezoneChange,
    editable,
    showTitle = true,
}: TimezoneSelectorProps) => {
    const timezoneOptions = React.useMemo(
        () =>
            Object.entries(timezones).map(([utc, timezoneInUtc]) => (
                <Select.OptGroup label={utc} key={utc}>
                    {Object.entries(timezoneInUtc).map(([name, id]) => (
                        <Select.Option value={id} label={name} key={name}>
                            {name}
                        </Select.Option>
                    ))}
                </Select.OptGroup>
            )),
        []
    );

    return (
        <>
            {showTitle && <h3>Timezone</h3>}
            <Select
                showSearch
                value={timezoneId ?? ''}
                style={{ maxWidth: '26em', width: '100%' }}
                optionLabelProp="label"
                optionFilterProp="label"
                onChange={onTimezoneChange}
                disabled={!editable}
                getPopupContainer={(node: HTMLElement) => node.parentNode as HTMLElement}
            >
                {timezoneOptions}
            </Select>
        </>
    );
};
export default TimezoneSelector;
